import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { TipoClassificacaoMultiselectModule } from '../../tipo-classificacao/multiselect';
import { ClassificacaoTipoMultiselectModule } from '../../classificacao/tipo/multiselect';
import { GrupoClassificacaoSituacaoModule } from '../situacao/grupo-classificacao-situacao.module';
import { GrupoClassificacaoConfigMultiselectModule } from '../config/multiselect';

import { GrupoClassificacaoFilterComponent } from './grupo-classificacao-filter.component';

@NgModule({
    imports: [
        SharedModule,
        TipoClassificacaoMultiselectModule,
        ClassificacaoTipoMultiselectModule,
        GrupoClassificacaoSituacaoModule,
        GrupoClassificacaoConfigMultiselectModule
    ],
    declarations: [
        GrupoClassificacaoFilterComponent
    ],
    exports: [
        GrupoClassificacaoFilterComponent
    ]
})
export class GrupoClassificacaoFilterModule { }
